/* eslint-disable no-console */

import MessageAdapter from './messageAdapter';
import { Log } from './interfaces';
import { authentication } from '../../authentication';
import { CORRELATION_ID } from '../../../constants/storage';

class ConsoleAdapter extends MessageAdapter {
  critical(message: string) {
    const correlationId = localStorage.getItem(CORRELATION_ID);

    console.error(message);
    console.trace();

    authentication.logout({ text: message, correlationId, severity: 'error' });
  }

  error(message: string) {
    console.error(message);
  }

  warn(message: string) {
    console.warn(message);
  }

  info(message: string) {
    console.info(message);
  }

  showLogs(logs: Log[]) {
    console.table(logs);
  }
}

export default ConsoleAdapter;
